export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20celebration%20atmosphere%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20stadium%20lights%20and%20confetti%2C%20abstract%20geometric%20patterns%2C%20cinematic%20and%20emotional%20mood%2C%20epic%20scale%2C%20professional%20sports%20event%20photography%20aesthetic%20with%20dramatic%20contrast&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt="华体会官网 - 加入我们"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          立即加入华体会官网
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
          注册即享新人专属福利，海量体育赛事、专业竞猜服务、全天候客服保障，华体会官网期待您的加入！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3 bg-accent-500 text-background-50 font-semibold rounded-md hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-sm md:text-base"
          >
            立即注册
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="#"
            className="px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap text-sm md:text-base"
          >
            联系客服
          </a>
        </div>
      </div>
    </section>
  );
}